export const SET_CURRENT_LANG = "SET_CURRENT_LANG";
export const GET_CURRENT_LANG = "GET_CURRENT_LANG";
